






import { Component,  Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'loading'
})

export default class Loading extends Vue {
    @Prop({ default: false })
    private loading?: boolean; 
}
